import * as React from "react";
import { Checkbox } from "informedv4";
import FailureWithMessage from "../../misc/components/FailureWithMessage";
import { Study } from "webportalclient";
import { useWebPortalApiClient } from "../../misc/api/WebPortalTokenClient";
import { TextBox } from "../../forms/informedv4/TextBoxV4";
import { Dropdown } from "../../forms/informedv4/DropdownV4";

interface EDiarySessionConfigurationProps {
    study: Study;
}

export const EDiarySessionConfiguration = ({ study }: EDiarySessionConfigurationProps) => {
    const [configurationFiles, setConfigurationFiles] = React.useState([]);
    const [failedToLoad, setFailedToLoad] = React.useState<string>();
    const client = useWebPortalApiClient();

    React.useEffect(() => {
        const getConfiguration = async () => {
            const configurationFiles = await client.client.getDiaryConfigurations(undefined, `studies/any(s: s/id eq ${study.id})`, undefined, "files");

            setConfigurationFiles(configurationFiles.value.flatMap(x => x.files).filter(x => !x.isStrings));
        };

        getConfiguration();
    }, []);

    if (failedToLoad) return <FailureWithMessage message={failedToLoad} />;

    return (
        <>
            <div className="row">
                <div className="form-group col-sm-6">
                    <label htmlFor="ResetDiaryOnUpload">Reset Diary on USB upload</label>
                    <p className="help-block">Whether the Diary should be reset to blank when this session is uploaded via USB</p>
                    <Checkbox name="ResetDiaryOnUpload" id="ResetDiaryOnUpload" field="ResetDiaryOnUpload" />&nbsp;
                </div>
                <div className="form-group col-sm-6">
                    <label htmlFor="IncludedInDailySummaryCompliance">Included In Daily Summary Compliance</label>
                    <p className="help-block">For diary sessions, whether the session is factored into the compliance that is shown in the Diary sessions daily summary colouring</p>
                    <Checkbox name="IncludedInDailySummaryCompliance" id="IncludedInDailySummaryCompliance" field="IncludedInDailySummaryCompliance" />
                </div>
            </div>

            <div className="row">
                <div className="form-group col-sm-6">
                    <label htmlFor="ExpectedMinimumTests">Expected minimum acceptable tests</label>
                    <p className="help-block">If the session has Spirometry captured, the expected minimum number of acceptable tests they should perform</p>
                    <TextBox name="ExpectedMinimumTests"  type="number" min="0" max="10" id="ExpectedMinimumTests" field="ExpectedMinimumTests" />
                </div>
                <div className="form-group col-sm-6">
                    <label htmlFor="ExpectedMinimumQuestionnaires">Expected minimum questionnaires answered</label>
                    <p className="help-block">If the session has Questionnaires captured, the expected minimum number of questionnaires answered</p>
                    <TextBox name="ExpectedMinimumQuestionnaires" type="number" min="0" max="10" id="ExpectedMinimumQuestionnaires" field="ExpectedMinimumQuestionnaires" />
                </div>
            </div>

            <div className="row">
                <div className="form-group col-md-12 col-xs-12">
                    <label htmlFor="configuration">Configuration</label>
                    <Dropdown
                        name="Configuration"
                        id="Configuration"
                        field="Configuration"
                    >
                        <option
                            key={"OptionBlank"}
                            value="blank"
                        ></option>
                        {configurationFiles.map(s => (
                            <option
                                key={`Option${s.id}`}
                                value={s.id}
                            >
                                {s.friendlyName !== undefined && s.friendlyName !== null && s.friendlyName != "" ? `${s.friendlyName} - ${s.name}` : s.name}
                            </option>
                        ))}
                    </Dropdown>
                </div>
            </div>
        </>
    );
};
